export const transformContentData = (posts, lists, locale) => {
  return [
    ...(lists?.map(list => ({
      label: list.shortHeading,
      href: `/${list.locale}/${list.slug}`
    })) || []),
    ...(posts?.map(post => ({
      label: post.shortHeading,
      href: `/${post.locale}/${post.category.slug}/${post.slug}`
    })) || [])
  ];
}
